<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" :data="model" :title="$t('Generate Blank QR Codes')" @hidden="onHidden"
                   @hide="onHide"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="$t('Submit')" :is-loading="loading" :content-in-form="false" scrollable>

      <div class="row">
        <div class="col-md-12">
          <b-form @submit.prevent="handleSubmit(onSubmit)">
            <button type="submit" hidden></button>
            <div class="row">
              <div class="col-md-12">
                <input-widget :autofocus="true" :model="model" attribute="amount" type="number"/>
              </div>
            </div>
          </b-form>
        </div>
      </div>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import InputWidget from "../../core/components/input-widget/InputWidget";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import QRCode from "./QRCode.model";
  import {ON_PDF_MODAL_DATA_RETRIEVE, ON_PDF_MODAL_OPEN} from "@/plugins/event-bus/event-bus-names";
  import InventoryService from "@/modules/inventory/InventoryService";

  const {mapState, mapActions} = createNamespacedHelpers('inventory');

  export default {
    name: "QRGenerateModal",
    components: {
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        model: new QRCode(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.qrGenerateModal,
      }),
    },
    methods: {
      ...mapActions(['hideQRGenerateModal']),
      onHide() {
      },
      onHidden() {
        this.model = new QRCode();
        this.hideQRGenerateModal();
      },
      async onSubmit() {
        this.$evBus.$emit(ON_PDF_MODAL_OPEN, {
          title: this.$i18n.t(`Blank QR Codes`)
        });
        let response = await InventoryService.getBlankQrCodePdfData(parseInt(this.model.amount));
        if (response.success) {
          this.$evBus.$emit(ON_PDF_MODAL_DATA_RETRIEVE, {
            ...response.body,
            filename: this.$i18n.t(`Blank QR Codes`)
          })
        }
        this.hideQRGenerateModal();
      },
    },
  }
</script>

<style scoped>

</style>
